@if (!this.isLoading) {
  <div class="instructions">
    <ol>
      <li>Download the mobile application</li>
      <li>Tap the QR Code icon and select <strong>Website Login</strong></li>
      <li>Point your device to the QR Code below</li>
    </ol>
  </div>
}
@if (!this.isLoading) {
  <div class="qr-code">
    @if (this.deviceId != null) {
      <qr-code value={{this.deviceId}} errorCorrectionLevel="H" size="300"
      centerImageSrc="../../assets/icteam-logo-black-total.jpg" centerImageSize="0"></qr-code>
    }
  </div>
}
@if (this.isLoading) {
  <div>
    <loading-spinner></loading-spinner>
  </div>
}